import { CalculationFunctionValuesEnum, MechanicStepType } from '../../model';

export const useMechanicStepDisabledRule = (
  record: MechanicStepType | null,
  calculationFunction: CalculationFunctionValuesEnum,
) => {
  switch (calculationFunction) {
    case CalculationFunctionValuesEnum.CF1:
      return record == null || !record.reward;
    case CalculationFunctionValuesEnum.CF2:
      return record == null || !record.reward;
    case CalculationFunctionValuesEnum.CF5:
      return record == null || !record.target;
    case CalculationFunctionValuesEnum.CF6:
      return record == null || !record.target || !record.reward;
    default:
      return record == null || !record.target || !record.reward;
  }
};
